'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('template-upload', {
      url: '/template/upload',
      template: '<template-upload></template-upload>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/template/template-upload/template-upload.routes.js